import React, { memo } from 'react';

import { Content, Section, Table, Title } from '@src/components/ui/Table';
import { useDictionariesFieldsMap } from '@src/reducers/dictionaries';
import { useCard } from '@src/reducers/product';
import {
  ageText,
  commentDocumentsText,
  documentsToSecurityText,
  guarantorText,
  optionalDocumentsText,
  requiredDocumentsText,
} from '@src/utils/texts';

interface IProps {
  className?: string;
}

function renderTableRow(text?: [string, string]) {
  if (!text) {
    return null;
  }

  const [name, value] = text;

  return (
    <Section key={name}>
      <Title size={6}>{name}</Title>
      <Content size={6}>{value}</Content>
    </Section>
  );
}

export const Requirements: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { className } = props;
  const dicts = useDictionariesFieldsMap();
  const card = useCard();

  if (!card.customerRequirements || !card.rates) {
    return null;
  }

  return (
    <Table className={className}>
      <tbody>
        {renderTableRow(ageText(card.customerRequirements))}
        {card.customerRequirements.demands
          ?.map((demand) => [dicts.demands[demand], 'да'] as [string, string])
          .map(renderTableRow)}
        {renderTableRow(guarantorText(card.security?.guarantor))}
        {renderTableRow(documentsToSecurityText(card.security?.list || [], dicts.security))}
        {renderTableRow(requiredDocumentsText(card.customerRequirements.documents, dicts.microCreditsDocuments))}
        {renderTableRow(commentDocumentsText(card.customerRequirements.documents))}
        {renderTableRow(optionalDocumentsText(card.customerRequirements.documents, dicts.microCreditsDocuments))}
      </tbody>
    </Table>
  );
});
